import React, {useCallback, useContext, useEffect, useState} from 'react'
import {useHttp} from '../hooks/http.hook'
import {AuthContext} from '../context/AuthContext'
import config from '../config.json'
import {
    getAuthHeader,
    objectLang,
    removeCookieOfFolderId,
    setErrorWindow
} from "../functions"
import {ModalWin} from "./ModalWin"
import {LoaderClass} from "./LoaderClass"
import {useNavigate} from "react-router-dom"

export const SaveFolder = ({folder}) => {

    const auth = useContext(AuthContext)
    const [allowed, setAllowed] = useState(true)
    const [dataModal, setDataModal] = useState({})
    const {request, loading} = useHttp()
    const navigate = useNavigate()

    let lang = objectLang().language
    const l = lang.lang

    const getData = useCallback(async () => {
        let host
        window.location.host === 'localhost:3000' ? host = config.localHost : host = config.onrender
        try {
            const data = await request(`${host}/api/folder/update/${folder._id}`, 'POST',
                {
                    parentFID: folder.parentFID,
                    name: folder.name,
                    description: folder.desc,
                    owner: folder.owner
                },
                {
                    Authorization: getAuthHeader(auth)
                })

            if (data.status > 201) {
                setAllowed(false)
                setDataModal(setErrorWindow('', data.code))
            } else {
                removeCookieOfFolderId(data.folder.parentFolder)
                localStorage.removeItem('folder-properties-data')
                navigate(`/${l}/folder/open/${data.folder.parentFolder}`, {replace: true})
            }
        } catch (e) {
            window.location.replace(`/${l}/`)
        }
    }, [auth, request, folder, l, navigate])

    useEffect(() => {
        if (!auth.isAuthenticated) {
            setAllowed(false)
            setDataModal(setErrorWindow(
                lang.body.errorPage.title,
                540,
                '',
                lang.body.errorPage.btnOK,
                'replaceToAuth',
                lang.body.errorPage.btnCancel,
                'replaceToBack'
            ))
        } else {
            getData().then()
        }
    }, [getData, auth, lang])

    if (loading) {
        return <LoaderClass/>
    }

    if (!allowed) {
        return (
            <>
                <ModalWin data={dataModal}/>
            </>

        )
    }
}
